<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h2 class="w-100">Subscriptions</h2>
    </div>
    <div class="title mb-4">
      <h3 class="w-100">
        <button
                [ngClass]="{'btn-primary btn': tabis === 1, 'btn btn-info': tabis !== 1}"
                (click)="vip_sub_transactions(1)" style="padding: 7px; border-radius: 9px; border: 0px;">
          MYVIP
        </button>
        -
        <button [ngClass]="{'btn-primary btn': tabis === 2, 'btn btn-info': tabis !== 2}" style="padding: 7px; border-radius: 9px; border: 0px;" (click)="vip_sub_transactions(2)">
          KACHIING BIZ
        </button>
        -
        <button  [ngClass]="{'btn-primary btn': tabis === 3, 'btn btn-info': tabis !== 3}" style="padding: 7px; border-radius: 9px; border: 0px;" (click)="vip_sub_transactions(3)">
          KACHIING MEMBER
        </button>
      </h3>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="white_box shadow p-3">
          <div class="row">
            <div class="col-md-12 add_ded_tbl"> 
              <table class="table" style="opacity: {{opacitytable}}">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Sr.No.</th>
                    <!--th-- scope="col">Subscription ID</!--th-->
                    <th scope="col">Customer</th>
                    <th scope="col">Status</th>
                    <th scope="col">Period</th>
                    <th scope="col">Creation Date</th>
                    <th scope="col">Canceled Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let i of transactions; let a = index">
                    <th scope="row">{{ transactions.length - a }}</th>

                    <!--td>{{ i.id }}</!--td-->
                    <td>{{ i.email }}</td>
                    <td>{{ i.status }}</td>
                    <td>
                      {{ showdiff(i.status, timestamp, i.current_period_end) }}
                    </td>
                    <td>{{ i.created * 1000 | date : "medium" }}</td>
                    <td>
                      <span *ngIf="i.canceled_at == null">N/A</span>
                      <span *ngIf="i.canceled_at != null">
                        {{ i.canceled_at * 1000 | date : "medium" }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
